import Vue from 'vue';
import VueRouter from 'vue-router';
import ForgotPassword from '@/views/ForgotPassword/ForgotPassword.vue';
import Home from '@/views/Home/Home.vue';
import Login from '@/views/Login/Login.vue';
import Register from '@/views/Register/Register.vue';
import Profile from '@/views/Profile/Profile.vue';
import InvoiceRegister from '@/views/InvoiceRegister/InvoiceRegister.vue';
import InvoiceList from '@/views/InvoiceList/InvoiceList.vue';
import LuckyNumbers from '@/views/LuckyNumbers/LuckyNumbers.vue';
import LuckyRoulette from '@/views/LuckyRoulette/LuckyRoulette.vue';
import Winners from '@/views/Winners/Winners.vue';
import TMAuth from '@/tools/TMAuth';
import ApiRequest from '@/tools/ApiRequest';
import MyGifts from '@/views/MyGifts/MyGifts.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/esqueci-minha-senha',
    name: 'Recuperação de Senha',
    component: ForgotPassword,
  },
  {
    path: '/cadastro',
    name: 'Cadastro',
    component: Register,
  },
  {
    path: '/perfil',
    name: 'Perfil',
    component: Profile,
  },
  {
    path: '/cadastrar-nota',
    name: 'Cadastrar Nota',
    component: InvoiceRegister,
  },
  {
    path: '/notas-enviadas',
    name: 'Notas Enviadas',
    component: InvoiceList,
  },
  {
    path: '/numeros-da-sorte',
    name: 'Números da Sorte',
    component: LuckyNumbers,
  },
  {
    path: '/giro-da-sorte',
    name: 'Roleta da Sorte',
    component: LuckyRoulette,
  },
  {
    path: '/ganhadores',
    name: 'Ganhadores',
    component: Winners,
  },
  {
    path: '/meus-premios',
    name: 'Meus prêmios',
    component: MyGifts,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = `${to.name} - Fanáticos Nortox`;

  next();
});

router.beforeEach((to, from, next) => {
  if (!TMAuth.isAuthenticated()) {
    if (to.name !== 'Login' && to.name !== 'Cadastro' && to.name !== 'Recuperação de Senha') {
      next('/login');
    }
  }

  next();
});

router.beforeEach((to, from, next) => {
  ApiRequest.getWinners().then((response) => {
    if (response.data.length > 0) {
      next('/ganhadores');
    } else {
      next();
    }
  });

  next();
});

export default router;
